import { component } from "picoapp";
import $ from "jquery";

export default component((node, ctx) => {
  const updateReviewsLoop = setInterval(() => {
    if ($(node).find(".sr-only")) {
      const starRating = $(node).find(".sr-only").text().split(" ")[0];
      const reviewsCount = $(node).find("a.text-m").text();
      $(node).find("a.text-m").text(`${starRating} (${reviewsCount})`);
      clearInterval(updateReviewsLoop);
    }
  }, 1000);
});
